"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sourceFragmentDependencies = exports.sourceFragment = void 0;
const filterFragment_1 = require("./filterFragment");
exports.sourceFragment = `
fragment sourceFragment on Source {
  id
  name
  type
  blockchainAddress
  applicableFilters {
    ...filterFragment
  }
}
`.trim();
exports.sourceFragmentDependencies = [
    ...filterFragment_1.filterFragmentDependencies,
    filterFragment_1.filterFragment,
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic291cmNlRnJhZ21lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvZnJhZ21lbnRzL3NvdXJjZUZyYWdtZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLHFEQUE4RTtBQUVqRSxRQUFBLGNBQWMsR0FBRzs7Ozs7Ozs7OztDQVU3QixDQUFDLElBQUksRUFBRSxDQUFDO0FBRUksUUFBQSwwQkFBMEIsR0FBRztJQUN4QyxHQUFHLDJDQUEwQjtJQUM3QiwrQkFBYztDQUNmLENBQUMifQ==